module.exports = __webpack_public_path__ + "static/media/logo.7fc3fd79.png";